import React, { useEffect, useState, forwardRef } from 'react';
import PropTypes from 'prop-types';
import {
  Slide,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from '@mui/material';
import {
  GAME_LISTING_COLUMNS,
  VIDEO_LISTING_COLUMNS,
} from '../../config/module-configs/game-video-sessions.config';
import Loading from '../table-elements/loading.component';
import ListData from '../table-elements/list-data.component';
import {
  gameSessionById,
  videoSessionById,
} from '../../services/reports.service';
import SnackbarInfo from '../common/snackbar-info.component';
import Iconify from '../common/iconify.component';

const Transition = forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const GameVideoSession = ({
  title,
  dataId,
  appType,
  onCancel,
  gameVideoSessions,
  isLive = false,
}) => {
  const gameColumns = GAME_LISTING_COLUMNS;
  const videoColumns = VIDEO_LISTING_COLUMNS;
  const renderColumnFilter = [];
  const actions = [];
  gameColumns.forEach((item) => {
    if (
      !(isLive && item.id === 'gameEndTime' && gameVideoSessions <= 1) ||
      !isLive
    ) {
      renderColumnFilter.push(item);
    }
  });
  const [renderColumns, setRenderColumns] = useState(renderColumnFilter);
  const [options, setOptions] = useState({
    page: 0,
    rowsPerPage: 10,
    totalRows: 0,
    rows: [],
    reloadCounter: 0,
    sortBy: '',
    sortOrder: '',
    error: false,
    loading: true,
    appliedFilters: {
      search: '',
      platforms: [],
      brd: null,
    },
    filtersCounter: 0,
  });

  const [loading, setLoading] = useState(true);
  const [snackbarInfo, setSnackbarInfo] = useState({
    show: false,
    type: '',
    message: '',
  });

  const handlePageChange = (v) => {
    setOptions({
      ...options,
      page: v,
      reloadCounter: options.reloadCounter + 1,
      loading: true,
    });
  };
  const handleRowsPerPageChange = (v) => {
    setOptions({
      ...options,
      rowsPerPage: v,
      page: 0,
      reloadCounter: options.reloadCounter + 1,
      loading: true,
    });
  };
  const handleSortingChange = (sortBy, sortOrder) => {
    setOptions({
      ...options,
      sortBy,
      sortOrder,
      reloadCounter: options.reloadCounter + 1,
      loading: true,
    });
  };
  const gameVideoSessionSuccess = (res, isGameSession) => {
    setOptions({
      ...options,
      loading: false,
      totalRows: res?.data?.totalRows || 0,
      rows: res?.data?.rows || [],
      error: false,
    });
    if (res?.data?.totalRows > 0) {
      let columnFilter = [];
      const firstItem = res?.data?.rows[0];
      if (isGameSession) {
        renderColumns.forEach((item) => {
          if (
            firstItem[item.dataKey] !== null &&
            firstItem[item.dataKey] !== undefined
          ) {
            columnFilter.push(item);
          }
        });
      } else {
        columnFilter = videoColumns;
      }
      setRenderColumns(columnFilter);
    }
    setLoading(false);
  };

  const gameVideoSessionError = (err) => {
    setOptions({
      ...options,
      loading: false,
      page: 0,
      totalRows: 0,
      rows: [],
      error: true,
    });
    const message =
      err.response?.data?.message || 'Something went wrong, please try again.';
    setSnackbarInfo({
      ...snackbarInfo,
      show: true,
      type: 'error',
      message,
    });
    setLoading(false);
  };

  useEffect(() => {
    const params = [];
    params.push(`page=${options.page + 1}`);
    params.push(`perPage=${options.rowsPerPage}`);
    if (options.sortBy && options.sortOrder) {
      params.push(`sortBy=${options.sortBy}`);
      params.push(`sortOrder=${options.sortOrder}`);
    }

    const paramsQuery = params.length > 0 ? `?${params.join('&')}` : '';
    if (appType === 'ottapp') {
      videoSessionById(dataId, paramsQuery)
        .then((res) => {
          gameVideoSessionSuccess(res, false);
        })
        .catch((err) => {
          gameVideoSessionError(err);
        });
    } else {
      gameSessionById(dataId, paramsQuery)
        .then((res) => {
          gameVideoSessionSuccess(res, true);
        })
        .catch((err) => {
          gameVideoSessionError(err);
        });
    }
  }, [dataId, options.reloadCounter]);

  return (
    <Dialog
      open
      onClose={() => onCancel()}
      aria-labelledby="view-dialog-title"
      aria-describedby="view-dialog-description"
      TransitionComponent={Transition}
      fullWidth
      maxWidth="lg"
    >
      <DialogTitle id="view-dialog-title">{title}</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onCancel}
        size="small"
        sx={{
          position: 'absolute',
          right: 10,
          top: 15,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <Iconify icon="ic:outline-close" />
      </IconButton>

      <DialogContent dividers id="view-dialog-description">
        {loading && <Loading />}

        {!loading && (
          <ListData
            columns={renderColumns}
            rows={options.rows}
            page={options.page}
            rowsPerPage={options.rowsPerPage}
            totalRows={options.totalRows}
            loading={options.loading}
            actions={actions}
            error={options.error}
            sortBy={options.sortBy}
            sortOrder={options.sortOrder}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
            onSortChange={handleSortingChange}
          />
        )}
      </DialogContent>

      {snackbarInfo.show && (
        <SnackbarInfo type={snackbarInfo.type} message={snackbarInfo.message} />
      )}
    </Dialog>
  );
};

GameVideoSession.propTypes = {
  title: PropTypes.string.isRequired,
  dataId: PropTypes.number.isRequired,
  appType: PropTypes.number.isRequired,
  onCancel: PropTypes.func.isRequired,
  isLive: PropTypes.bool.isRequired,
  gameVideoSessions: PropTypes.number.isRequired,
};

export default GameVideoSession;
